export const LAYOUT_PUBLIC_HOME = '/public/home'

export const LAYOUT_PUBLIC_CAMPAIGN_ROOT = '/public/campaign'
export const LAYOUT_PUBLIC_CAMPAIGN_FORM = (hash, media) =>
    `/public/campaign/${hash}` + (media ? '?media=' + media : '')
export const LAYOUT_PUBLIC_CAMPAIGN_INACTIVE = '/public/campaign/inactive'
export const LAYOUT_PUBLIC_CAMPAIGN_SUCCESS = '/public/campaign/success'
export const LAYOUT_PUBLIC_CAMPAIGN_SHOW = '/public/campaign/form'

export const LAYOUT_PUBLIC_ACCESS_ROOT = '/public/access'
export const LAYOUT_PUBLIC_ACCESS_ACCEPTED = (hash) => `/public/access/accepted/${hash}`
export const LAYOUT_PUBLIC_ACCESS_RESET = (hash) => `/public/access/reset/${hash}`
export const LAYOUT_PUBLIC_ACCESS_SUCCESS = '/public/access/success'
export const LAYOUT_PUBLIC_ACCESS_ERROR = '/public/access/error'
